import type {User} from 'firebase/auth';

export class FirebaseUser {
  static user: User | null = null;
}
